"use client"
import { ROUTES } from "@/@core/constants/routes";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/translationContext";
import { usePlausible } from "next-plausible";
import { CLICK_QUOTE_EVENT_SECTIONS, PLAUSIBLE_GOAL_KEYS } from "@/@core/constants/plausible";
import { Link } from "@/components/CustomLink";
import ArrowLongRightIcon from "@heroicons/react/24/solid/ArrowLongRightIcon";
import { cn } from "@/lib/utils";
import { useIsAskQuestionEnabled } from "@/hooks/useIsAskQuestionEnabled";

interface HeroQuoteButtonProps {
  fullWidth?: boolean;
  withArrow?: boolean;
  buttonClassName?: string;
}

export default function HeroQuoteButton({ fullWidth = false, withArrow = false, buttonClassName }: HeroQuoteButtonProps) {
  const { t } = useTranslation();
  const plausible = usePlausible();
  const getTitle = t("quote-button-title");
  const isAskQuestionEnabled = useIsAskQuestionEnabled();

  const sendPlausibleEvent = () => {
    try {
      plausible(PLAUSIBLE_GOAL_KEYS.CLICK_QUOTE_EVENT, {
        props: {
          section: CLICK_QUOTE_EVENT_SECTIONS.HOMEPAGE_FIRST_SCREEN,
        },
      });
    } catch (error) {
      console.error("Plausible event gönderiminde hata:", error);
    }
  };

  if (!isAskQuestionEnabled) return null;

  return (
    <Link
      onClick={() => sendPlausibleEvent()}
      title={getTitle}
      aria-label={getTitle}
      href={ROUTES.CONTACT_WITH_VENUES}
      className={cn(fullWidth && "w-full")}
    >
      <Button
        aria-label={getTitle}
        variant="gradient"
        className={cn(
          "!h-12 flex items-center font-bold text-base justify-center gap-2 px-4 py-2",
          fullWidth && "w-full rounded-lg",
          buttonClassName,
        )}
      >
        {getTitle}
        {withArrow && <ArrowLongRightIcon className="size-5" />}
      </Button>
    </Link>
  )
}